/* eslint-disable no-nested-ternary */
import format from "date-fns/format";
import { keyBy } from "lodash/fp";
import {
  ALL_DATES,
  INTEGER_KEYS,
  AppliedFilterLabelMap,
  DATES,
  DROPDOWN_KEYS,
  DROPDOWN_REDUX_KEY_MAPPER,
  EXCLUDE_DATES,
  OS_DROPDOWN_KEYS,
} from "../../../contants";
import { ROUTES } from "../../../utils/constants";
import { isEmptyObj, isOSKey } from "../../../utils/helper";

const DATE_FORMAT = "yyyy-MM-dd";
const PLUS = "plus";
// const OS_LABEL = "organisationStructure";
export const POSITIONS_KEY = "positions";
export const MAINLINE_POSITION_KEY = "appliedFor";

export const performOperation = (value, limit, operator = PLUS) =>
  operator === PLUS ? Number(value) + limit : Number(value) - limit;

export const getConferralRoutePath = () =>
  ROUTES.REPORTS_GOHONZON_CONFERRAL.path;

export const getAllotmentRoutePath = () =>
  ROUTES.REPORTS_GOHONZON_ALLOTMENT.path;

const handleOS = (queryObject, currObj, key) => {
  // const currentOS = currObj[OS_LABEL] ?? {};

  return Object.assign(currObj, {
    // [OS_LABEL]: { ...currentOS,
    [key]: Number(queryObject[key]),
  });
};

export const getFormattedQuery = (queryObject) =>
  !isEmptyObj(queryObject)
    ? Object.keys(queryObject).reduce((acc, currKey) => {
        let value = queryObject[currKey];
        // console.log(value);
        const key = currKey;

        if (INTEGER_KEYS.includes(currKey)) {
          value = Number(queryObject[currKey]);
        } else if (ALL_DATES.includes(currKey)) {
          value = format(new Date(queryObject[currKey]), DATE_FORMAT);
        } else if (OS_DROPDOWN_KEYS.includes(currKey)) {
          return handleOS(queryObject, acc, currKey);
        }
        return Object.assign(acc, {
          [key]: value,
        });
      }, {})
    : {};

export const getFilters = (queryObject, metaData, disabledOSKeys) =>
  Object.keys(queryObject).reduce((acc, curr) => {
    if (
      !EXCLUDE_DATES.includes(curr) &&
      (queryObject[curr] !== "size" || queryObject[curr] !== "number")
    ) {
      // handle dates
      // handle dates
      if (DATES.includes(curr)) {
        // ✅ NEW: handle plain from/to
        if (curr === "from") {
          acc.push({
            key: curr,
            displayName:
              AppliedFilterLabelMap.period ||
              AppliedFilterLabelMap.from ||
              "Period",
            value: `${queryObject.from} - ${queryObject.to || ""}`,
            disabled: disabledOSKeys.includes(curr),
          });
          return acc;
        }

        // ✅ keep existing From/To behaviour for other date filters
        const key = curr.split("From")[0];
        acc.push({
          key: curr,
          displayName: AppliedFilterLabelMap[key],
          value: `${queryObject[curr]} - ${queryObject[`${key}To`]}`,
          disabled: disabledOSKeys.includes(curr),
        });
        return acc;
      }

      // handle dropdowns
      if (DROPDOWN_KEYS.includes(curr) || OS_DROPDOWN_KEYS.includes(curr)) {
        const pool = isOSKey(curr)
          ? metaData.organisationStructure[DROPDOWN_REDUX_KEY_MAPPER[curr]]
          : metaData[DROPDOWN_REDUX_KEY_MAPPER[curr]];

        const selectedValue = pool.find(
          (p) =>
            (p.structureId ||
              p.divisionId ||
              p.cityId ||
              p.stateId ||
              p.positionId) === Number(queryObject[curr])
        );

        acc.push({
          key: curr,
          displayName: AppliedFilterLabelMap[curr],
          value:
            selectedValue?.name ||
            selectedValue?.name ||
            selectedValue?.cityName ||
            selectedValue?.stateName ||
            selectedValue?.name ||
            queryObject[curr],
          disabled: disabledOSKeys.includes(curr),
        });
        return acc;
      }

      // if ([POSITIONS_KEY, MAINLINE_POSITION_KEY].includes(curr)) {
      //   const positionsMap = keyBy("value", metaData.appliedFor);
      //   const inputPositions = queryObject[curr].split(",");

      //   const positionsLabel = inputPositions?.map(
      //     (postion) => positionsMap[postion]?.entityTitle
      //   );

      //   acc.push({
      //     key: curr,
      //     displayName: AppliedFilterLabelMap[curr],
      //     value: positionsLabel.join(", "),
      //   });
      //   return acc;
      // }

      // if ([MAINLINE_POSITION_KEY].includes(curr)) {
      //   const positionsMap = keyBy("value", metaData.appliedFor);
      //   const inputPositions = queryObject[curr].split(",");

      //   const positionsLabel = inputPositions?.map(
      //     (postion) => positionsMap[postion]?.entityTitle
      //   );

      //   acc.push({
      //     key: curr,
      //     displayName: "Positions",
      //     value: positionsLabel.join(", "),
      //   });
      //   return acc;
      // }

      if ([MAINLINE_POSITION_KEY].includes(curr)) {
        const positionsMap = keyBy("value", metaData.appliedFor);
        const inputPositions = queryObject[curr].split(",");

        const positionsLabel = inputPositions?.map(
          (position) => positionsMap[position]?.entityTitle
        );

        acc.push({
          key: curr,
          displayName: "Positions",
          value: positionsLabel.join(", "),
        });
        return acc;
      }

      // rest
      acc.push({
        key: curr,
        displayName: AppliedFilterLabelMap[curr],
        value: queryObject[curr],
        disabled: disabledOSKeys.includes(curr),
      });
      return acc;
    }
    return acc;
  }, []);

export const handleDependencyFilter = (query) => {
  const updatedQueryWithOS = { ...query };
  if (!updatedQueryWithOS?.areaId) {
    delete updatedQueryWithOS.zoneId;
    delete updatedQueryWithOS.regionId;
    delete updatedQueryWithOS.chapterId;
    delete updatedQueryWithOS.districtId;
    delete updatedQueryWithOS.blockId;
  } else if (!updatedQueryWithOS?.zoneId) {
    delete updatedQueryWithOS.regionId;
    delete updatedQueryWithOS.chapterId;
    delete updatedQueryWithOS.districtId;
    delete updatedQueryWithOS.blockId;
  } else if (!updatedQueryWithOS?.regionId) {
    delete updatedQueryWithOS.chapterId;
    delete updatedQueryWithOS.districtId;
    delete updatedQueryWithOS.blockId;
  } else if (!updatedQueryWithOS?.chapterId) {
    delete updatedQueryWithOS.districtId;
    delete updatedQueryWithOS.blockId;
  } else if (!updatedQueryWithOS?.districtId) {
    delete updatedQueryWithOS.districtId;
    delete updatedQueryWithOS.blockId;
  }

  // state and divisions
  if (!updatedQueryWithOS?.state) {
    delete updatedQueryWithOS.city;
  }

  return updatedQueryWithOS;
};
